var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { on: { click: _vm.toggleClick } }, [
    _c(
      "div",
      { staticClass: "hamburger", class: { "is-active": !_vm.isActive } },
      [_c("svg-icon", { attrs: { "icon-class": "a-icon_putaway" } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }